import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import compose from '@nubank/nuds-web/utils/functional/compose';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage, { headerTypes, footerTypes } from 'hoc/websitePage/websitePage';
import { MULTI_PRODUCT } from 'utils/prospectTypes';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionBusiness from './patterns/SectionBusiness/SectionBusiness';
import SectionOverview from './patterns/SectionOverview/SectionOverview';
import SectionKeys from './patterns/SectionKeys/SectionKeys';
import SectionFAQ from './patterns/SectionFAQ/SectionFAQ';
import SectionStraightforward from './patterns/SectionStraightforward/SectionStraightforward';
import SectionTransfer from './patterns/SectionTransfer/SectionTransfer';
import SectionLearnMore from './patterns/SectionLearnMore/SectionLearnMore';
import SectionPromo from './patterns/SectionPromo/SectionPromo';

function PixPage({ onFormVisibilityChange }) {
  const { formatMessage } = useContext(NuDsContext);

  const pixCardsArea = formatMessage({ id: 'cms.pixPage.pixCardsArea' });

  const CARDS_MAP = {
    SectionOverview,
    SectionKeys,
    SectionStraightforward,
    SectionTransfer,
    SectionPromo,
    SectionBusiness,
    SectionFAQ,
    SectionLearnMore,
  };

  return (
    <>
      <SectionForm onFormVisibilityChange={onFormVisibilityChange} />
      {pixCardsArea?.length && pixCardsArea.map((pixCard, index) => {
        const CardComponent = CARDS_MAP[pixCard.componentName];

        if (!CardComponent) return null;

        return (
          <CardComponent
            key={pixCard.id}
            index={index}
          />
        );
      })}
    </>
  );
}

PixPage.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default compose(
  websitePage({
    routeKey: 'PIX',
    footer: footerTypes.COMPANY_INFO,
    header: headerTypes.FEATURE_PAGE,
    widgetProspectType: MULTI_PRODUCT,
  }),
  memo,
)(PixPage);
